export const TOOLTIPS = {
  PRACTICE: "The name of the practice where the service was rendered.",
  PRACTICE_NAME: "The official name of your medical/dental practice.",
  PRACTICE_ADDRESS: "The physical address where your practice is located.",
  PRACTICE_TAX_ID:
    "The 9-digit Employer Identification Number (EIN) for your practice.",
  NPI: "National Provider Identifier - a unique 10-digit number assigned to healthcare providers.",
  BILLING_PROVIDER:
    "The provider/NPI listed on the claim. This can either be the rendering provider, a group or a facility.",
  RENDERING_PROVIDER:
    "The provider who actually performed the service. Can be the same as the billing provider if they're the same person.",
  REQUEST_TYPE: "The type of inquiry you want to make.",
  DESIRED_COMPLETION_DATE:
    "The date by which you need the results of this inquiry.",
  PLACE_OF_SERVICE:
    "The location where the service was rendered (e.g., office, hospital).",
  IS_SPECIALIST:
    "Specify if the provider is a specialist (e.g., periodontist, cardiologist).",
  CLAIMS_DATE_OF_SERVICE: "The date the service was rendered for the claim.",
  BILLED_AMOUNT: "The total amount billed for the service.",
  ELIGIBILITY_SEARCH_QUERIES:
    "Select the specific eligibility information you need.",
  PROCEDURE_CODES:
    "CPT/CDT or HCPCS codes. Can either be for procedures or drugs.",
  DIAGNOSIS_CODES: "ICD-10 or other codes for the patient's diagnosis.",
  ADDITIONAL_INFO:
    "Include any other context that might be helpful for this request. You may also include additional questions as a one-off for this request.",
};
